import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { atom, useRecoilState } from "recoil";
import { GetMoneyValue, getThousandComma } from "../../Api/ApiCommon";
import LineBtn from "../../components/Button/LineBtn";
import ExcelDownload from "../../components/DefaultStyles/ExcelDownload";
import LineBox from "../../components/DefaultStyles/LineBox";
import Loader from "../../components/DefaultStyles/Loader";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import DropDown, { OptionType } from "../../components/Filters/DropDown";
import Search from "../../components/Filters/Search";
import {
  FailTableBodyItem,
  IPayFail,
  TableBodyItemChild,
} from "../../components/pages/Pay/PayFail/CalculatePayFail";
import PayExecuteModal from "../../components/pages/Pay/ReservedPay/PayExecuteModal";
import ReservedPayDetail from "../../components/pages/Pay/ReservedPay/ReservedPayDetail";
import Pagination from "../../components/Table/Pagination";
import Table, { TableBody } from "../../components/Table/Table";
import { useApi } from "../../hooks/useApi";
import { Filters, TotalCount } from "../Users/UserInfo";
import { payTypeString } from "./PayInfo";
import { PartyInfoFilterContainer } from "../../components/pages/Party/PartyInfo/PartyInfoFilter";
import Flex from "../../components/DefaultStyles/Flex";
import AllImmediatePay from "../../components/pages/Pay/ReservedPay/AllImmediatePay";
import AllSendMesssage from "../../components/pages/Pay/ReservedPay/AllSendMesssage";
import ConfirmBtn from "../../components/Button/ConfirmBtn";
import SaveModal from "../../components/pages/Pay/ReservedPay/SaveModal";
import {
  PointTabBar,
  PointTabColumn,
  PointTabContainer,
  PointTabText,
} from "../../components/pages/Benefit/Point/PointTab";
import styled from "styled-components";

export const reservedPayDropdown = atom<OptionType>({
  key: "reservedPayDropdown",
  default: {
    value: "",
    label: "선택",
  },
});

export const reservedPaySearch = atom<string | undefined>({
  key: "reservedPaySearch",
  default: "",
});

export const validCheckTabState = atom<number>({
  key: "validCheckTabState",
  default: 0,
});

export const reservedPayPage = atom<number>({
  key: "reservedPayPage",
  default: 0,
});

export default function ReservedPay() {
  const navigate = useNavigate();

  const [savedPage, setSavedPage] = useRecoilState<number>(reservedPayPage);
  const [page, setPage] = useState(savedPage);

  useEffect(() => {
    setSavedPage(page);
  }, [page]);

  const [dropDownValue, setDropDownValue] =
    useRecoilState<OptionType>(reservedPayDropdown);
  const [searchValue, setSearchValue] = useRecoilState<string | undefined>(
    reservedPaySearch
  );
  const [btnClick, setBtnClick] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [activeDetailIndex, setActiveDetailIndex] = useState<number | null>(
    null
  );
  const [payExecuteModal, setPayExecuteModal] = useState(false);
  const [executeData, setExecuteData] = useState({
    user: "",
    id: "",
  });
  const [saveModal, setSaveModal] = useState(false);
  const [tab, setTab] = useRecoilState(validCheckTabState);

  const [logData, setLogData] = useState<any>({
    cdname: "",
    charge: 0,
    comm: 0,
    coupon: 0,
    deposit: 0,
    money: 0,
    point: 0,
    time: "",
  });

  const { response, loading, fetchData } = useApi({
    method: "get",
    url:
      `pay/0?page=${page}&size=10&diffdate=${tab}` +
      (searchValue ? `&${dropDownValue?.value}=${searchValue}` : ``),
  });

  console.log(response?.data?.items);

  const tableHead = [
    "UID_이름_닉네임",
    "실패 이유",
    "회차",
    "PID",
    "금액",
    "다음 결제 일시",
    "결제 수단 변경 일시",
    "보기",
    "결제",
  ];

  const options: OptionType[] = [
    { value: "uid", label: "UID" },
    { value: "name", label: "이름" },
    { value: "nickname", label: "닉네임" },
    { value: "phone", label: "전화번호" },
    { value: "partyid", label: "PID" },
  ];

  useEffect(() => {
    setTimeout(() => {
      setBtnClick(false);
    }, 100);
  }, [page]);

  return (
    <>
      <PageTitle title="예약 결제" />

      <PointTabContainer>
        <PointTabColumn onClick={() => setTab(0)}>
          <PointTabText isActive={Boolean(tab === 0)}>정산일</PointTabText>

          <PopupTabBar tab={tab} />
        </PointTabColumn>

        <PointTabColumn onClick={() => setTab(1)}>
          <PointTabText isActive={Boolean(tab === 1)}>정산일+1</PointTabText>
        </PointTabColumn>

        <PointTabColumn onClick={() => setTab(2)}>
          <PointTabText isActive={Boolean(tab === 2)}>정산일+2</PointTabText>
        </PointTabColumn>
      </PointTabContainer>

      <PartyInfoFilterContainer maxWidth={1000}>
        <Flex gapSize={10}>
          <DropDown
            isDisabled={false}
            setDropDownValue={setDropDownValue}
            dropdownValue={dropDownValue}
            optionList={options}
          />

          <Search
            placeholder="입력"
            setSearchValue={setSearchValue}
            isDisabled={dropDownValue ? false : true}
            pageResetEvent={() => setPage(0)}
            defaultValue={searchValue !== "" ? searchValue : undefined}
            inputType={
              dropDownValue?.value === "partyid" ||
              dropDownValue?.value === "phone" ||
              dropDownValue?.value === "uid"
                ? "number"
                : undefined
            }
          />
        </Flex>

        <Flex gapSize={10}>
          {tab === 2 ? (
            <AllSendMesssage totalCount={+response?.data?.totalCount ?? 0} />
          ) : (
            <></>
          )}

          <AllImmediatePay
            fetch={() =>
              fetchData({
                method: "get",
                url:
                  `pay/0?page=${page}&size=10&diffdate=${tab}` +
                  (searchValue
                    ? `&${dropDownValue?.value}=${searchValue}`
                    : ``),
              })
            }
          />

          {/* <ConfirmBtn
            btnText="구제하기"
            btnColor="mint"
            btnClickEvent={() => setSaveModal(true)}
          /> */}
        </Flex>
      </PartyInfoFilterContainer>

      <LineBox>
        <Table tableHeadData={tableHead} tableMinWidth={840}>
          <>
            {response?.data?.items?.map((d: IPayFail, index: number) => {
              return (
                <React.Fragment key={index}>
                  <TableBody>
                    <FailTableBodyItem
                      style={{
                        textDecoration: "underline",
                        cursor: "pointer",
                        verticalAlign: "baseline",
                      }}
                            onClick={() => {
                      setSavedPage(page);
                      navigate(`/users/info/${d?.uid}`);
                    }}
                    >
                      <TableBodyItemChild>
                        {d?.uid}_{d?.name}_{d?.nickname}
                      </TableBodyItemChild>
                    </FailTableBodyItem>

                    <FailTableBodyItem style={{ verticalAlign: "baseline" }}>
                      <TableBodyItemChild>
                        {d?.reason !== "" ? d?.reason : "-"}
                        {d?.log[0]?.pg ? ` (${d?.log[0]?.pg})` : ""}
                      </TableBodyItemChild>
                    </FailTableBodyItem>

                    <FailTableBodyItem style={{ verticalAlign: "baseline" }}>
                      <TableBodyItemChild>
                        {d?.trycount +" / 12" }
                      </TableBodyItemChild>
                    </FailTableBodyItem>

                    <FailTableBodyItem
                      style={{
                        textDecoration: "underline",
                        cursor: "pointer",
                        padding: 0,
                      }}
                    >
                      {d?.log?.map((data, i: number) => (
                        <TableBodyItemChild
                          key={i}
                          selected={
                            d?.log?.length > 1 &&
                            logData?.partyid === data?.partyid &&
                            btnClick
                          }
                                      onClick={() => {
                            setSavedPage(page);
                            navigate(`/party/info/${data?.partyid}`);
                          }
                          }
                        >
                          {data?.partyid}
                        </TableBodyItemChild>
                      ))}
                    </FailTableBodyItem>

                    <FailTableBodyItem style={{ padding: 0 }}>
                      {d?.log?.map((data, i: number) => (
                        <TableBodyItemChild
                          selected={
                            d?.log?.length > 1 &&
                            logData?.partyid === data?.partyid &&
                            btnClick
                          }
                          style={{
                            fontWeight: "bold",
                          }}
                          key={i}
                        >
                          {GetMoneyValue(data?.logdata?.amount)}
                        </TableBodyItemChild>
                      ))}
                    </FailTableBodyItem>

                    <FailTableBodyItem>
                      {d?.log?.map((data, i: number) => (
                        <TableBodyItemChild
                          key={i}
                          selected={
                            d?.log?.length > 1 &&
                            logData?.partyid === data?.partyid &&
                            btnClick
                          }
                        >
                          {dayjs(d?.time)?.format("YYYY-MM-DD HH:mm")}
                        </TableBodyItemChild>
                      ))}
                    </FailTableBodyItem>

                    <FailTableBodyItem>
                      {d?.log?.map((data, i: number) => (
                        <TableBodyItemChild
                          key={i}
                          selected={
                            d?.log?.length > 1 &&
                            logData?.partyid === data?.partyid &&
                            btnClick
                          }
                        >
                          {d?.lastCardChange
                            ? dayjs(d?.lastCardChange)?.format(
                                "YYYY-MM-DD HH:mm"
                              )
                            : "-"}
                        </TableBodyItemChild>
                      ))}
                    </FailTableBodyItem>

                    <FailTableBodyItem>
                      {d?.log?.map((data, i: number) => {
                        return (
                          <TableBodyItemChild
                            key={i}
                            selected={
                              d?.log?.length > 1 &&
                              logData?.partyid === data?.partyid &&
                              btnClick
                            }
                          >
                            <LineBtn
                              btnText={
                                logData?.partyid === data?.partyid && btnClick
                                  ? "접기"
                                  : "보기"
                              }
                              btnClickEvent={() => {
                                const time = {
                                  time: d?.time,
                                };

                                setLogData({
                                  ...data,
                                  ...time,
                                });

                                setActiveIndex(index);
                                setActiveDetailIndex(i);

                                if (d?.log?.length > 1) {
                                  if (activeDetailIndex === i) {
                                    setBtnClick(!btnClick);
                                  } else {
                                    setBtnClick(true);
                                  }
                                } else {
                                  if (activeIndex === index) {
                                    setBtnClick(!btnClick);
                                  } else {
                                    setBtnClick(true);
                                  }
                                }
                              }}
                            />
                          </TableBodyItemChild>
                        );
                      })}
                    </FailTableBodyItem>

                    <FailTableBodyItem>
                      {d?.log?.map((data, i: number) => (
                        <TableBodyItemChild
                          key={i}
                          selected={
                            d?.log?.length > 1 &&
                            logData?.partyid === data?.partyid &&
                            btnClick
                          }
                        >
                          <LineBtn
                            btnText="결제"
                            btnClickEvent={() => {
                              setExecuteData({
                                id: d?.id ?? "",
                                user: `${d?.uid}_${d?.name}_${d?.nickname}`,
                              });
                              setPayExecuteModal(true);
                            }}
                          />
                        </TableBodyItemChild>
                      ))}
                    </FailTableBodyItem>
                  </TableBody>

                  {activeIndex === index && btnClick && (
                    <ReservedPayDetail data={logData} />
                  )}
                </React.Fragment>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      <ExcelDownload
        disabled={false}
        dataUrl={
          `pay/schedule/excel?page=0&size=1000` +
          (searchValue ? `&${dropDownValue?.value}=${searchValue}` : ``)
        }
        title="예약 결제"
        tableHead={[
          "UID_이름_닉네임",
          "전화번호",
          "실패 이유",
          "PID",
          "적요",
          "금액",
          "총액",
          "다음 결제 시간",
          "보기",
        ]}
        pushedData={(d: IPayFail) => {
          return [
            `${d?.uid}_${d?.name}_${d?.nickname}`,
            `${d?.phone ?? "-"}`,
            `${d?.reason !== "" ? d?.reason : "-"}`,
            `${d?.log?.map((data) => `${data.partyid}`)}`,
            `${d?.log?.map((data) => `${payTypeString(data?.reason, true)}`)}`,
            `${d?.log?.map(
              (data) => `${GetMoneyValue(data?.logdata?.amount)}`
            )}`,
            `${GetMoneyValue(
              d?.log
                .map((o) => o?.logdata?.amount ?? 0)
                .reduce((a: number, c: number) => a + c)
            )}`,
            `${dayjs(d?.time)?.format("YYYY-MM-DD HH:mm")}`,
          ];
        }}
      />

      {loading && <Loader />}

      {payExecuteModal && (
        <PayExecuteModal
          closeEvent={() => setPayExecuteModal(false)}
          executeData={executeData}
          successEvent={() =>
            fetchData({
              method: "get",
              url:
                `pay/0?page=${page}&size=10` +
                (searchValue ? `&${dropDownValue?.value}=${searchValue}` : ``),
            })
          }
        />
      )}

      {saveModal && <SaveModal closeEvent={() => setSaveModal(false)} />}
    </>
  );
}

const PopupTabBar = styled(PointTabBar)`
  width: ${({ tab }) => (tab === 0 ? 50 : 70)}px;
  left: ${({ tab }) => (tab === 0 ? 0 : tab === 1 ? 65 : 152)}px;
`;
